import { apiClient } from "./client";

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export interface CurrentUser {
  id: number;
  email: string;
  role: string;
  is_active: boolean;
  is_verified: boolean;
  first_name?: string | null;
  last_name?: string | null;
}

export const AuthApi = {
  login: (email: string, password: string) =>
    apiClient.post<LoginResponse>("/auth/login", { email, password }),
  me: () => apiClient.get<CurrentUser>("/users/me"),
};
